import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";

const PromoDataRecovery = () => {
  return (
    <Box
      sx={{
        position: "relative",
        background: "linear-gradient(160deg, #0d0d0d, #1c1c1c)",
        color: "#fff",
        overflow: "hidden",
        px: { xs: 3, md: 8 },
        py: { xs: 6, md: 12 },
        textAlign: "center",
      }}
    >
      {/* Elementos de Fondo */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
          background: `radial-gradient(circle at 20% 30%, rgba(255,102,0,0.08), transparent 70%),
                       radial-gradient(circle at 80% 80%, rgba(255,255,255,0.06), transparent 60%)`,
        }}
      />
      <Box
        sx={{
          content: '""',
          position: "absolute",
          top: "15%",
          right: "-5%",
          width: "220px",
          height: "220px",
          background: "rgba(255,102,0,0.12)",
          borderRadius: "50%",
          filter: "blur(30px)",
        }}
      />
      <Box
        sx={{
          content: '""',
          position: "absolute",
          bottom: "10%",
          left: "-8%",
          width: "280px",
          height: "150px",
          background: "rgba(255,255,255,0.05)",
          borderRadius: "40% 60% 70% 30% / 60% 30% 40% 70%",
          transform: "rotate(-15deg)",
        }}
      />

      <Box sx={{ position: "relative", zIndex: 1, maxWidth: "850px", mx: "auto" }}>
        
        {/* Imagen Responsiva */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <Box
            component="img"
            src={require("../../static/media/service/recuperacion_datos.webp")}
            alt="Laboratorio de Recuperación de Datos y Análisis Forense"
            sx={{
              width: "60%",
              maxWidth: "750px", // Limita el tamaño en pantallas grandes para no pixelar
              height: "auto",
              borderRadius: "16px",
              boxShadow: "0px 15px 35px rgba(0, 0, 0, 0.6)",
              mb: 5, // Margen inferior para separar del título
              display: "block",
              mx: "auto",
              border: "1px solid rgba(255,255,255,0.05)"
            }}
          />
        </motion.div>

        {/* Título */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.3rem" },
              fontWeight: "bold",
              mb: 3,
              color: "#ff6600",
            }}
          >
            Recuperación de Datos y Análisis Forense
          </Typography>
        </motion.div>

        {/* Texto */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "0.95rem", sm: "1.05rem", md: "1.15rem" },
              lineHeight: 1.8,
              mb: 5,
              color: "rgba(255,255,255,0.9)",
            }}
          >
            En <strong>CMSOLTEC</strong> contamos con herramientas y personal especializado 
            en la recuperación de datos desde discos duros y dispositivos defectuosos. Además, 
            realizamos análisis forense digital para la identificación, preservación y evaluación 
            de información crítica.
          </Typography>
        </motion.div>
      </Box>
    </Box>
  );
};

export default PromoDataRecovery;